import React from 'react';

export const PrimaryField = (field) => {
  const { value, ...rest } = field.input;
  const Icon = field.icon;
  return (
    <div className={`input-group input-group_primary ${field.meta.touched && field.meta.error ? 'input-group_error ' : ' '} ${field.icon && 'input-group_iconed'}`}>
      {field.icon &&
        (
          <div className="input-group__icon">
            <Icon />
          </div>
        )
      }
      <input id={field.name} type={field.type} {...rest} placeholder={field.placeholder} value={value || ''} />
      { field.meta.touched && field.meta.error && (
        <span>
          {field.meta.error}
        </span>
      )}
    </div>
  );
};

export default PrimaryField;
